import React, { useState, useEffect } from 'react';
import './CSS/LoginSignup.css';

const LoginSignup = () => {
    // --- State and handlers from your original logic ---
    const [state, setState] = useState("Login");
    const [formData, setFormData] = useState({
        username: "",
        password: "",
        email: "",
    });

    // --- State for the UI ---
    const [passwordStrength, setPasswordStrength] = useState({ width: '0%', color: '#f00' });
    
    // --- The unused emailError and passwordError states have been REMOVED ---
    
    const changeHandler = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // --- Your original login and signup functions are preserved ---
    const login = async () => {
        console.log("Login Function Executed", formData);
        let responseData;
        try {
            const response = await fetch('/api/login', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            responseData = await response.json();
            if (responseData.success) {
                localStorage.setItem('auth-token', responseData.token);
                window.location.replace("/");
            } else {
                alert(responseData.errors);
            }
        } catch (error) {
            console.error("Network error", error);
        }
    };

    const signup = async () => {
        console.log("Signup Function Executed", formData);
        let responseData;
        try {
            const response = await fetch('/signup', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            responseData = await response.json();
            if (responseData.success) {
                localStorage.setItem('auth-token', responseData.token);
                window.location.replace("/");
            } else {
                alert(responseData.errors);
            }
        } catch (error) {
            console.error("Network error", error);
        }
    };
    
    // --- The unused validation and storeCredentials functions can be removed if not needed elsewhere ---
    // If you need them, keep them. For this example, I'll assume they can be cleaned up.

    useEffect(() => {
        const password = formData.password;
        if (!password) {
            setPasswordStrength({ width: '0%', color: '#f00' });
            return;
        }
        let complexity = 0;
        if (password.length >= 6) complexity++;
        if (/[a-z]/.test(password)) complexity++;
        if (/[A-Z]/.test(password)) complexity++;
        if (/[0-9]/.test(password)) complexity++;
        if (/[!@#$%^&*()_+]/.test(password)) complexity++;
        const strengthPercent = (complexity / 5) * 100;
        let strengthColor = '#f00';
        if (strengthPercent > 20) strengthColor = '#ff4500';
        if (strengthPercent > 40) strengthColor = '#ffbf00';
        if (strengthPercent > 60) strengthColor = '#3cba54';
        if (strengthPercent > 80) strengthColor = '#4caf50';
        setPasswordStrength({ width: `${strengthPercent}%`, color: strengthColor });
    }, [formData.password]);


    return (
        <section className='loginsignup'>
            <div className="loginsignup-container">
                <h1>{state}</h1>
                <div className="loginsignup-fields">
                    {state === "Sign Up" && (
                        <div className="form-group">
                            <label htmlFor="username">Username</label>
                            <input id="username" name='username' value={formData.username} onChange={changeHandler} type="text" placeholder='e.g. John Doe' />
                        </div>
                    )}
                    <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <input id="email" name='email' value={formData.email} onChange={changeHandler} type="email" placeholder='your@email.com' />
                        {/* Error message display is removed as the state is gone */}
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input id="password" name='password' value={formData.password} onChange={changeHandler} type="password" placeholder='Enter your password' />
                        <div className="password-strength-meter">
                            <div className="strength-bar" style={{ width: passwordStrength.width, backgroundColor: passwordStrength.color }}></div>
                        </div>
                        {/* Error message display is removed as the state is gone */}
                    </div>
                </div>
                <button className="loginsignup-button" onClick={() => { state === "Login" ? login() : signup() }}>Continue</button>
                {state === "Sign Up"
                    ? <p className='loginsignup-login'>Already have an account? <span onClick={() => setState("Login")}>Login here</span></p>
                    : <p className='loginsignup-login'>Create an account? <span onClick={() => setState("Sign Up")}>Click here</span></p>}
                <div className="loginsignup-agree">
                    <input type="checkbox" id="agreeCheckbox" name='agreeCheckbox' />
                    <label htmlFor="agreeCheckbox">By continuing, I agree to the terms of use & privacy policy.</label>
                </div>
            </div>
        </section>
    );
};

export default LoginSignup;